module.exports = __webpack_public_path__ + "img/valor_medio_dos_produtos.81223a09.png";